import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/create-staking.css';

function Create() {
    const [ranks] = useState([
        { rank: '1000 - 4999', interest: '+0.5%' },
        { rank: '5000 - 19999', interest: '+1%' },
        { rank: '20000 - 49999', interest: '+2%' },
        { rank: '50000 - 99999', interest: '+3%' },
        { rank: '100000 - 499999', interest: '+4%' },
        { rank: '500000 - Higher', interest: '+5%' },
    ]);

    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');
    const [balance, setBalance] = useState(null);
    const [userData, setUserData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchBalance = async () => {
            const storedUser = localStorage.getItem('user');
            if (storedUser) {
                const user = JSON.parse(storedUser);
                setUserData(user);
                fetchUserBalance(user.username);
            }
        };

        fetchBalance();
    }, []);

    const fetchUserBalance = async (username) => {
        try {
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${baseUrl}/wallet/username/${username}`);
            const data = await response.json();

            if (data && data.amount !== undefined) {
                setBalance(data.amount);  // ✅ Store the correct balance
            }
        } catch (error) {
            console.error('Error fetching user balance:', error);
        }
    };

    const handleAmountChange = (e) => {
        const value = e.target.value;
        setAmount(value);

        if (!value) {
            setError('Please enter an amount.');
        } else if (isNaN(value)) {
            setError('Amount must be a number.');
        } else if (Number(value) < 1000) {
            setError('Amount must be at least 1000.');
        } else {
            setError('');
        }
    };

    const handleSendRequest = () => {
        if (!error && amount) {
            navigate(-1);
        }
    };

    const isButtonDisabled = !amount || !!error || Number(amount) < 1000;

    return (
        <div className="Create-page">
            <div className="create-container">
                <table className="styled-table">
                    <thead>
                        <tr>
                            <th>Rank</th>
                            <th>Interest</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ranks.map((rank, index) => (
                            <tr key={index}>
                                <td>{rank.rank}</td>
                                <td>{rank.interest}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <br />
                <div className="request-card">
                <div className="request-info">
                    <label>Available Balance</label>
                    <span>{balance !== null ? `$${balance.toLocaleString()}` : 'Loading...'}</span> {/* ✅ Fixed */}
                </div>
                <div className="request-input">
                    <label>Amount</label>
                    <input
                        type="number"
                        value={amount}
                        onChange={handleAmountChange}
                        placeholder="1000"
                    />
                    {error && <span className="error-message">{error}</span>}
                </div>
                <button className="send-request-button" disabled={isButtonDisabled} onClick={handleSendRequest}>
                    SEND REQUEST
                </button>
            </div>
            </div>

            
        </div>
    );
}

export default Create;
